module.exports = __webpack_public_path__ + "static/img/ihme-ilmat-miksi-ilmasto-muuttuu.6f77b2d.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/ihmeilmat/ihme-ilmat-miksi-ilmasto-muuttuu.jpg
// module id = I9WX
// module chunks = 1